import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthRoleGuard } from './modules/shared/components/auth/auth-role.guard';
import { HomeComponent } from './modules/app/pages/home/home.component';
import { AuthGuard } from './modules/shared/components/auth/auth.guard';
import { NotAuthorizedComponent } from './modules/shared/pages/not-authorized-compoment';
import { Permissions } from './config/AppEnums';

const routes: Routes = [

  {
    path: '', component: HomeComponent, pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'callback', redirectTo: ''
  },
  {
    path: 'hr',
    loadChildren: () => import('./modules/hr/hr.module').then(m => m.HRModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.OrganisationList, Permissions.OrganisationView, Permissions.OrganisationManage, Permissions.OrganisationRolesManage, Permissions.UserAdvancedView,
        Permissions.UserAdvancedManage, Permissions.ContractManagerAdministration]
    }
  },
  {
    path: 'ims',
    loadChildren: () => import('./modules/ims/ims.module').then(m => m.ImsModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.ImsModule, Permissions.EMSManage, Permissions.EMSView]
    }
  }, 
  {
    path: 'kpi',
    loadChildren: () => import('./modules/kpi/kpi.module').then(m => m.KpiModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.Kpi_Admin, Permissions.Kpi_Capture, Permissions.Kpi_Reports]
    }
  },
  {
    path: 'sales-reports',
    loadChildren: () => import('./modules/sales-reports/sales-reports.module').then(m => m.SalesReportsModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.SuperAdmin]
    }
  },
  {
    path: 'mqs',
    loadChildren: () => import('./modules/mqs/mqs.module').then(m => m.MQSModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.SuperAdmin]
    }
  },
  {
    path: 'stock',
    loadChildren: () => import('./modules/stock/stock.module').then(m => m.StockModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.StockItemsModule, Permissions.StockItemsModuleView, Permissions.SupplierEdit, Permissions.SupplierManageDocuments,Permissions.ViewCreditors, Permissions.EditCreditors]
    }
  },
  {
    path: 'reports',
    loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.SuperAdmin]
    }
  },

  {
    path: 'app-reports',
    loadChildren: () => import('./modules/app-reports/app-reports.module').then(m => m.AppReportsModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: []
    }
  },{
    path: 'catalogue',
    loadChildren: () => import('./modules/catalogue/catalogue.module').then(m => m.CatalogueModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: []
    }
  },
 // {
 //   path: 'import',
 //   loadChildren: './modules/import/import.module#ImportModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [Permissions.ImportsModule]
 //   }
 // }, {
 //   path: 'stock',
 //   loadChildren: './modules/stock/stock.module#StockModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [Permissions.StockItemsModule, Permissions.StockItemsModuleEdit, Permissions.StockItemsModuleView, Permissions.SupplierEdit, Permissions.SupplierManageDocuments]
 //   }
 // }, {
 //   path: 'dashboard',
 //   loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [Permissions.DashboardModule]
 //   }
 // },
  {
    path: 'requisition',
    loadChildren: () => import('./modules/requisition/requisition.module').then(m => m.RequisitionModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.RequisitionCreate,
        Permissions.ProcurementApproval,
        Permissions.RequisitionApproval,
        Permissions.StockRequisition, Permissions.RequisitionJobManagement]
    }
  },
  {
    path: 'usermodulesvisited',
    loadChildren: () => import('./modules/usermodulesvisited/usermodulesvisited.module').then(m => m.UserModulesVisitedModule),
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.UserModulesVisited, Permissions.SuperAdmin]
    }
  },
 // {
 //   path: 'reqdashboard',
 //   loadChildren: './modules/req-dashboard/req-dashboard.module#ReqDashboardModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [
 //       Permissions.ProcurementApproval]
 //   }
 // },
 // {
 //   path: 'reqreports',
 //   loadChildren: './modules/req-reports/req-reports.module#ReqReportsModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [
 //       Permissions.ProcurementApproval, Permissions.OutstandingItemsReport]
 //   }
 // },
 // {
 //   path: 'ims',
 //   loadChildren: './modules/ims/ims.module#ImsModule',
 //   canActivate: [AuthRoleGuard],
 //   data: {
 //     expectedPermissions: [Permissions.ImsModule, Permissions.EMSManage, Permissions.EMSView]
 //   }
 // },
 // {
 //   path: 'party',
 //   loadChildren: './modules/party/party.module#PartyModule',
 //   canActivate: [AuthGuard],
 // }, 
 // {
 //   path: 'invoicing',
 //   loadChildren: './modules/invoicing/invoicing.module#InvoicingModule',
 //   canActivate: [AuthGuard],
 // },
 // {
 //   path: 'jse',
 //   loadChildren: './modules/jse/jse.module#JSEModule',
 //   canActivate: [AuthGuard],
	//},
	//{
	//	path: 'detailedwip',
	//	loadChildren: './modules/detailed-wipreport/detailed-wipreport.module#DetailedWipreportModule',
	//	canActivate: [AuthGuard],
 // },
  {
    path: 'tender',
    loadChildren: () => import('./modules/tender/tender.module').then(m => m.TenderModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'scaffolding-material',
    loadChildren: () => import('./modules/scaffolding-material/scaffolding-material.module').then(m => m.ScaffoldingMaterialModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'capex',
    loadChildren: () => import('./modules/capex/capex.module').then(m => m.CapexModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sps',
    loadChildren: () => import('./modules/sps/sps.module').then(m => m.SPSModule),
    canActivate: [AuthGuard],
  },
  
  { path: 'unauthorised', component: NotAuthorizedComponent },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { enableTracing: false } // <-- debugging purposes only
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
